// extracted by mini-css-extract-plugin
module.exports = {"chesshotel":"Board_chesshotel__kit2x","staunty":"Board_staunty__C3aEJ","brown":"Board_brown__cwAk1","brown-light":"Board_brown-light__nEVwQ"};